<template>
	<v-sheet no-gutters class="pl-2" dark width="100%" height="100%" :color="event.color">
		<div class="d-flex align-center">
			<span class="headline">{{ event.booking.user.name }}</span>
			<v-spacing></v-spacing>
			<span class="pl-5 subtitle-2">{{ event.booking.begin_time }} - {{ event.booking.end_time }}</span>
			<span class="pl-5 subtitle-2">{{ $n(event.booking.price, 'currency') }}</span>
		</div>
	</v-sheet>
</template>

<script>
export default {
	name: 'Booking',

	props: {
		event: {
			type: Object,
			required: true
		}
	}
}
</script>

<style lang="scss" scoped></style>
